<!-- 采购订单 待确认订单-->
<template>
  <div>
    <el-row style="margin-top: 20px;">
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium" label-suffix="：">
          <el-form-item label="副仓" v-if="subWarehouseList && subWarehouseList.length > 1">
            <el-select v-model="searchForm.SUB_WAREHOUSE" filterable placeholder="请选择副仓" clearable multiple
              collapse-tags style="width: 200px;">
              <el-option v-for="item in subWarehouseList" :key="item.ID" :label="item.AB_NAME"
                :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商">
            <el-select v-model="searchForm.TC_COMPANY" filterable placeholder="请选择供应商" clearable @clear="clearEvent"
              @change="queryFirstTC">
              <el-option v-for="item in companys" :key="item.SUPPLIER_ID" :label="item.NAME"
                :value="item.SUPPLIER_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单ID">
            <el-input v-model="searchForm.orderCode" style="width: 180px;" clearable @clear="clearEvent"></el-input>
          </el-form-item>
          <el-form-item label="日期范围">
            <el-date-picker v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions1"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="整单备注">
            <el-input size="medium" clearable v-model="searchForm.REMARKS" placeholder="请输入整单备注"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="doQueryTable">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-button size="medium" type="primary" plain @click="exportAllOrder" v-if="fun_dic[101050001]">批量导出</el-button>
      <el-button size="medium" v-show="activeName == 'supplierConfirmList'" @click="submitAll">一键确认</el-button>
      <tooltip-button :disabled="Boolean(searchForm.DAY_INTERVAL && searchForm.DAY_INTERVAL[0])" tipContent="请先选择日期范围"
        buttonType="primary" buttonPlain buttonText="导出PDF" buttonSize="medium" @click="pdfVisible = true">
      </tooltip-button>
    </el-row>
    <el-row style="margin-top: 20px;">
      <el-col>
        <el-tabs type="border-card" @tab-click="changeStaus" v-model="activeName">
          <el-tab-pane name="confirmList">
            <span slot="label">待确认订单</span>
            <el-table :data="tableData" border stripe show-summary style="width: 100%; margin-top: 20px;"
              :summary-method="getSummaries">
              <el-table-column prop="ORDER_ID" width="100" label="订单ID"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="订单编号"></el-table-column>
              <el-table-column prop="SEND_DAY" label="送货日期"></el-table-column>
              <el-table-column prop="SUPPLIER_NAME" label="供应商"></el-table-column>
              <el-table-column prop="TOTAL_GYS_FEE" label="总价"></el-table-column>
              <el-table-column prop="TOTAL_WEIGHT" label="总重"></el-table-column>
              <el-table-column prop="REMARKS" label="整单备注" min-width="90"></el-table-column>
              <el-table-column fixed="right" label="操作" width="190">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="check(scope.row)">验收</el-button>
                  <el-button type="text" size="small" @click="copyOrder(scope.row)">复制订单</el-button>
                  <el-button type="text" size="small" @click="viewContract(scope.row)">订单资质</el-button>
                  <el-button type="text" size="small" @click="output(scope.row)">导出</el-button>
                  <el-button type="text" size="small" @click="outputDoc(scope.row)">导出入库单</el-button>
                  <el-button type="text" size="small" @click="orderPrint(scope.row, 'print')">打印</el-button>
                  <el-button type="text" size="small" @click="shortOrderPrint(scope.row, 'shortPrint')">短打印</el-button>
                  <el-button type="text" size="small" v-if="fun_dic[101050002]"
                    @click="修改订单(scope.row)">修改订单</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-col :span="24" style="text-align: right">
              <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
                :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totalCount">
              </el-pagination>
            </el-col>
          </el-tab-pane>
          <el-tab-pane name="supplierConfirmList">
            <span slot="label">待供应商确认</span>
            <el-table :data="tableSupplierData" @selection-change="handleSelectionChange" border stripe show-summary
              style="width: 100%;margin-top:20px" :summary-method="getSummaries">
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="ORDER_ID" width="100" label="订单ID"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="订单编号"></el-table-column>
              <el-table-column prop="SEND_DAY" label="送货日期"></el-table-column>
              <el-table-column prop="SUPPLIER_NAME" label="供应商"></el-table-column>
              <el-table-column prop="TOTAL_GYS_FEE" label="总价"></el-table-column>
              <el-table-column prop="TOTAL_WEIGHT" label="总重"></el-table-column>
              <el-table-column prop="REMARKS" label="整单备注" min-width="90"></el-table-column>
              <el-table-column fixed="right" label="操作" width="190">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="detail(scope.row)">查看</el-button>
                  <el-button type="text" size="small" @click="viewContract(scope.row)">订单资质</el-button>
                  <el-button type="text" size="small" @click="outputSupplier(scope.row)">导出</el-button>
                  <el-button type="text" size="small" @click="outputDoc(scope.row)">导出入库单</el-button>
                  <el-button type="text" size="small" @click="orderPrint(scope.row, 'print')">打印</el-button>
                  <el-button type="text" size="small" @click="shortOrderPrint(scope.row, 'shortPrint')">短打印</el-button>
                  <el-button type="text" size="small" v-if="fun_dic[101050002]"
                    @click="修改订单(scope.row)">修改订单</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-col :span="24" style="text-align: right">
              <el-pagination @current-change="handleCurrentChange1" :current-page.sync="currentPage1"
                :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totalCount1">
              </el-pagination>
            </el-col>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <el-dialog title="选择订单信息" center :visible.sync="copyFormVisible" width="500px" :close-on-click-modal="false">
      <el-form :model="copyForm" ref="copyForm" size="small" :rules="rules" label-suffix="："
        :label-width="formLabelWidth">
        <el-form-item label="供应商" prop="GYS">
          <el-select v-model="copyForm.GYS" clearable filterable style="width:90%">
            <el-option v-for="item in companys" :key="item.SUPPLIER_ID" :label="item.NAME"
              :value="item.SUPPLIER_ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="送货日期" prop="SEND_DAY">
          <el-date-picker :clearable="false" v-model="copyForm.SEND_DAY" type="date" placeholder="选择日期"
            value-format="yyyy-MM-dd" style="width:90%">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="copyFormVisible = false">取 消</el-button>
        <el-button size="small" @click="submitCopy('copyForm')" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="以下商品在此供应商中无价格" :visible.sync="unCopyVisible" width="600px" center :close-on-click-modal="false">
      <el-table :data="unTableData" border stripe style="width: 100%">
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
        <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="产品单位"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="unCopyVisible = false">取 消</el-button>
        <el-button size="small" @click="unCopyVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 单个订单导出PDF -->
    <el-dialog title="导出PDF" center :visible.sync="exportDocDialog" width="520px" :close-on-click-modal="false">
      <el-form size="small" :model="exportDocForm" ref="orderPrintForm" :inline="true" :rules="rules" label-suffix="："
        label-width='150px'>
        <el-form-item label="是否带价格">
          <el-radio v-model="exportDocForm.printPrice" label="0">不带价格</el-radio>
          <el-radio v-model="exportDocForm.printPrice" label="1">带价格</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="printClose">取 消</el-button>
        <el-button size="small" :loading="loading3" @click="submitexportDoc('exportDocForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 打印 -->
    <el-dialog :title="printType == 'print' ? '打印' : '短打印'" center :visible.sync="realCountDialog" width="550px"
      @close="closeRealCountDialog">
      <el-form size="small" :model="exportDocForm" ref="orderPrintForm" :inline="true" :rules="rules" label-suffix="："
        label-width='150px'>
        <el-form-item label="是否带实收">
          <el-radio-group v-model="realCountRadio">
            <el-radio :label="1" style='margin-left: 25px'>是</el-radio>
            <el-radio :label="0" style='margin-left: 100px'>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否填充实收" v-if="realCountRadio == 1">
          <el-radio-group v-model="fillerRealCountRadio">
            <el-radio :label="1" style='margin-left: 25px'>是</el-radio>
            <el-radio :label="0" style='margin-left: 100px'>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="printType == 'shortPrint'" label="是否带分类">
          <el-radio-group v-model="catalogRadio">
            <el-radio :label="1" style='margin-left: 25px'>是</el-radio>
            <el-radio :label="0" style='margin-left: 100px'>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否打印生产日期">
          <el-radio-group v-model="productionDate">
            <el-radio :label="1" style='margin-left: 25px'>是</el-radio>
            <el-radio :label="0" style='margin-left: 100px'>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否打印库位">
          <el-radio-group v-model="是否带库位">
            <el-radio :label="1" style='margin-left: 25px'>是</el-radio>
            <el-radio :label="0" style='margin-left: 100px'>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否带保质日期">
          <el-radio-group v-model="是否带保质日期">
            <el-radio :label="1" style='margin-left: 25px'>是</el-radio>
            <el-radio :label="0" style='margin-left: 100px'>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-tooltip effect="dark" content="可填写打印抬头名称,不填写默认原样式" placement="top">
          <el-form-item label="抬头">
            <el-input v-model="订单自定义名称" clearable></el-input>
          </el-form-item>
        </el-tooltip>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeRealCountDialog">取 消</el-button>
        <el-button @click="print">确 定</el-button>
      </div>
    </el-dialog>
    <V-PurchaseOrderExportPDFForm :Visible="pdfVisible" :orderStatus="4" :startEnd="[...searchForm.DAY_INTERVAL]"
      @close="pdfVisible = false">
    </V-PurchaseOrderExportPDFForm>

    <el-dialog title="修改订单" center :visible.sync="修改订单模态框" width="500px" :close-on-click-modal="false">
      <el-form size="medium" :model="修改订单表单" ref="修改订单表单" :inline="true" label-suffix="：" label-width='120px'>
        <el-form-item label="供应商">
          <el-select v-model="修改订单表单.SUPPLIER_ID" filterable placeholder="请选择供应商" clearable style="width: 300px;">
            <el-option v-for="item in companys" :key="item.SUPPLIER_ID" :label="item.NAME"
              :value="item.SUPPLIER_ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="送货日期">
          <el-date-picker size="medium" v-model="修改订单表单.SEND_DAY" type="date" placeholder="选择日期" :clearable="true"
            style="width: 300px;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="修改订单模态框 = false">取 消</el-button>
        <el-button size="small" @click="确认修改订单()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getConfirmOrderFun, deleteOrderFun, copyOrderFun, exportSingleDocFunc, exportHistoryFun, exportConfirmAllFun, exportNewOrdeFun,
} from '@/assets/api/shopOrderManage';
import { frontEndFun } from '@/assets/api/frontFun';
import { queryActiveSupplierList } from '@/assets/api/customerManage';
import http from '@/assets/common/http';
import VPurchaseOrderExportPDFForm from './purchaseOrderExportPDFForm';
import date from '@/assets/common/date';

export default {
  data () {
    return {
      subWarehouseList: JSON.parse(sessionStorage.getItem('subWarehouseList')), // 副仓
      PAGE_ID: '1010500', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 101050001: 0, 101050002: 0 }, // 功能ID 一旦规定不要轻易改动
      tableSupplierData: [],
      formLabelWidth: '120px',
      rules: {
        customer: [
          { required: true, message: '请选择供应商', trigger: 'blur' },
        ],
        SEND_DAY: [
          { required: true, message: '请选择送货日期', trigger: 'blur' },
        ],
        GYS: [
          { required: true, message: '请选择供应商', trigger: 'blur' },
        ],
      },
      copyFormVisible: false,
      copyForm: {},
      loading: false,
      addForm: {
        customer: '',
        project: '',
        SEND_DAY: new Date(),
      },
      tableData: [],
      currentPage: 1,
      totalCount: 0,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      searchForm: {
        DAY_INTERVAL: [],
      },
      companys: [],
      pickerOptions1: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          },
        }],
      },
      pickerOptions: {},
      formLableWidth: '100px',
      orderId: '',
      unTableData: [],
      unCopyVisible: false,
      exportDocForm: {
        printPrice: '0',
      },
      exportDocDialog: false,
      loading3: false,
      currentPage1: 1,
      totalCount1: 0,
      ORDER_ID_LIST: [],
      activeName: sessionStorage.getItem('s_confirmOrderListActiveName') || 'confirmList',
      realCountDialog: false,
      realCountRadio: 0,
      fillerRealCountRadio: 0,
      catalogRadio: 0,
      productionDate: 1,
      是否带库位: 0,
      是否带保质日期: 0,
      订单自定义名称: localStorage.getItem('purchaseToBeConfirmedOrderPrintTitle') || `${sessionStorage.getItem('company')}采购单`,
      printType: '',
      pdfVisible: false,
      修改订单模态框: false,
      修改订单表单: {},
    };
  },
  async created () {
    this.queryBeforeFun();
    this.queryCustomer();
    if (sessionStorage.getItem('confirmOrderListCondition')) {
      const { searchForm, currentPage, currentPage1 } = JSON.parse(sessionStorage.getItem('confirmOrderListCondition'));
      this.searchForm = searchForm;
      this.currentPage = currentPage;
      this.currentPage1 = currentPage1;
      sessionStorage.removeItem('confirmOrderListCondition');
    } else {
      if (this.CONFIRM_DATA_CONDITION.CONDITION) {
        this.searchForm = this.CONFIRM_DATA_CONDITION.CONDITION;
        this.currentPage = this.CONFIRM_DATA_CONDITION.CURRENT_PAGE;
      } else {
        this.currentPage = 1;
      }
      if (this.CONFIRM_DATA_CONDITION_S.CONDITION) {
        this.searchForm = this.CONFIRM_DATA_CONDITION_S.CONDITION;
        this.currentPage1 = this.CONFIRM_DATA_CONDITION_S.CURRENT_PAGE;
      } else {
        this.currentPage1 = 1;
      }
    }
    await this.queryOrderList();
    await this.querySupplierList();
  },
  components: {
    VPurchaseOrderExportPDFForm,
  },
  computed: {
    CONFIRM_DATA_CONDITION () {
      return this.$store.state.CONFIRM_DATA_CONDITION;
    },
    CONFIRM_DATA_CONDITION_S () {
      return this.$store.state.CONFIRM_DATA_CONDITION_S;
    },
  },
  methods: {
    确认修改订单 () {
      const params = {
        SERVICE_ID: '10003',
        OTYPE: 57,
        ORDER_ID: this.修改订单表单.ORDER_ID,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_ID: this.修改订单表单.SUPPLIER_ID,
        SEND_DAY: date(this.修改订单表单.SEND_DAY, '%F'),
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.修改订单模态框 = false;
        this.修改订单表单 = {};
        this.querySupplierList();
        this.queryOrderList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    修改订单 (row) {
      this.修改订单模态框 = true;
      this.修改订单表单.ORDER_ID = row.ORDER_ID;
    },
    clearEvent () {
      this.queryOrderList();
      this.querySupplierList();
    },
    // 控制功能按钮
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 打印、短打印
    shortOrderPrint (row, printType) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      this.realCountDialog = true;
      this.printType = printType;
    },
    orderPrint (row, printType) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      this.realCountDialog = true;
      this.printType = printType;
    },
    print () {
      sessionStorage.setItem('confirmOrderListCondition', JSON.stringify({
        searchForm: this.searchForm,
        currentPage: this.currentPage,
        currentPage1: this.currentPage1,
      }));

      localStorage.setItem('purchaseToBeConfirmedOrderPrintTitle', this.订单自定义名称);
      sessionStorage.setItem('realCountFlag', this.realCountRadio);
      sessionStorage.setItem('productionDate', this.productionDate);
      sessionStorage.setItem('打印订单ID', true);
      sessionStorage.setItem('是否带库位', this.是否带库位);
      sessionStorage.setItem('是否带保质日期', this.是否带保质日期);
      sessionStorage.setItem('订单自定义名称', this.订单自定义名称);
      if (this.realCountRadio == 1) {
        sessionStorage.setItem('fillerRealCountRadio', this.fillerRealCountRadio);
      }
      this.closeRealCountDialog();
      if (this.printType === 'print') {
        this.$router.push({ name: 's_orderPrint' }); // 打印
      } else {
        this.$router.push({ name: 'shortOrderPrint' }); // 短打印
        sessionStorage.setItem('catalogFlag', this.catalogRadio);
      }
    },
    closeRealCountDialog () {
      this.realCountRadio = 0;
      this.realCountDialog = false;
    },
    // 复制订单
    copyOrder (row) {
      this.copyFormVisible = true;
      this.copyForm = row;
    },
    // 复制订单模态框的提交
    submitCopy () {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          // 执行代码
          const params = {
            ORDER_ID: this.copyForm.ORDER_ID,
            SUPPLIER_ID: this.copyForm.GYS,
            SEND_DAY: this.copyForm.SEND_DAY,
            PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
          };
          this.loading = true;
          copyOrderFun(params).then((result) => {
            if (result[0].DATA.length !== 0) {
              this.copyFormVisible = false;
              this.unTableData = result[0].DATA;
              this.unCopyVisible = true;
              this.loading = false;
            } else {
              this.loading = false;
              this.copyFormVisible = false;
              this.$message.show({ text: '复制成功', type: 'success' });
              this.queryOrderList();
            }
          }).catch((error) => {
            this.loading = false;
            this.$message.show({ text: error, type: 'error' });
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    // 多选
    handleSelectionChange (val) {
      const ORDER_ID_LIST = [];
      val.forEach((item) => { ORDER_ID_LIST.push(item.ORDER_ID); });
      this.ORDER_ID_LIST = ORDER_ID_LIST;
    },
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 6) {
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === 'TOTAL_GYS_FEE') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Math.floor((prev + value) * 100) / 100;
            }
            return prev;
          }, 0);
        }
      });
      this.sums = sums;
      return sums;
    },
    // 一键确认
    submitAll () {
      if (this.ORDER_ID_LIST.length == 0) {
        this.$message.show({ text: '请勾选需要确认的订单', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '10176',
        OTYPE: 14,
        ORDER_ID_LIST: this.ORDER_ID_LIST,
      };
      http.post(params).then((result) => {
        this.querySupplierList();
        this.$message.show({ text: '确认成功', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 订单资质
    viewContract (row) {
      this.$router.push({ name: 's_contantract', params: { id: row.ORDER_ID } });
      sessionStorage.setItem('menuName', 2);
    },
    // --------------------------------------选择供应商
    queryFirstTC (e) {
      this.searchForm.TC_ID = e;
    },
    // -------------------------------拉取供应商信息
    queryCustomer () {
      const params = {};
      if (this.addForm.customer) {
        params.SUPPLIER_NAME = this.addForm.customer;
      }
      queryActiveSupplierList(params).then((list) => {
        this.companys = list;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ----------------------------------拉取供应商信息
    queryProject (e) {
      this.addForm.TC_ID = e;
    },
    // -----------------------------------筛选功能
    queryTable () {
      this.queryOrderList();
    },
    // -----------------------------------页码
    handleCurrentChange (e) {
      this.currentPage = e;
      this.queryOrderList();
    },
    handleCurrentChange1 (e) {
      this.currentPage1 = e;
      this.querySupplierList();
    },
    // --------------------------------------进入页面拉取数据
    async queryOrderList () {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        ORDER_STATUS: 3,
      };
      if (this.searchForm.TC_COMPANY) {
        params.VENDOR_ID = Number(this.searchForm.TC_COMPANY);
      }
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.orderCode) {
        params.ORDER_ID = this.searchForm.orderCode;
      }
      if (this.searchForm.REMARKS) {
        params.REMARKS = this.searchForm.REMARKS;
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.GYS_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      await getConfirmOrderFun(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_CONFIRM_DATA_CONDITION', {
            CONDITION: this.searchForm,
            TOTAL_COUNT: this.totalCount,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    async querySupplierList () {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage1 - 1,
        ORDER_STATUS: 4,
      };
      if (this.searchForm.TC_COMPANY) {
        params.VENDOR_ID = Number(this.searchForm.TC_COMPANY);
      }
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.orderCode) {
        params.ORDER_ID = this.searchForm.orderCode;
      }
      if (this.searchForm.REMARKS) {
        params.REMARKS = this.searchForm.REMARKS;
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.GYS_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      await getConfirmOrderFun(params).then((result) => {
        if (result.length !== 0) {
          this.tableSupplierData = result[0].list;
          this.totalCount1 = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_CONFIRM_DATA_CONDITION_S', {
            CONDITION: this.searchForm,
            DATA: this.tableSupplierData,
            TOTAL_COUNT: this.totalCount1,
            CURRENT_PAGE: this.currentPage1,
          });
        } else {
          this.tableSupplierData = [];
          this.totalCount1 = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    async doQueryTable () {
      this.currentPage = 1;
      this.currentPage1 = 1;
      await this.queryOrderList();
      await this.querySupplierList();
    },
    detail (row) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('orderCode', row.ORDER_CODE);
      sessionStorage.setItem('supplierId', row.SUPPLIER_ID);
      this.$router.push({ path: '/supplierComfirmDetail/detail' });
    },
    // ---------------------------------------------待确认订单验收
    check (row) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('supplierID', row.SUPPLIER_ID);
      this.$router.push({ path: '/shopConfirmOrderDetail/detail' });
    },
    // ------------------------------------------待供应商确认验收
    waitingCheck (row) {
      this.$router.push({ name: 'orderCheck_supplier' });
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('supplierID', row.SUPPLIER_ID);
    },
    // ----------------------------------------------删除订单
    deleteOrder (row) {
      this.$confirm('确定删除此订单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          ORDER_ID: row.ORDER_ID,
        };
        deleteOrderFun(params).then((result) => {
          this.$message.show({ text: '删除成功', type: 'success' });
          this.queryTable();
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '已取消删除' });
      });
    },
    // ----------------------------导出订单
    output (row) {
      const orderId = [];
      orderId.push(Number(row.ORDER_ID));
      const params = {
        ORDER_IDS: orderId,
      };
      exportNewOrdeFun(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 导出送货单
    outputDoc (row) {
      this.exportDocForm.ID = row.ORDER_ID;
      this.exportDocDialog = true;
    },
    submitexportDoc () {
      const params = {
        PRICE_FLAG: Number(this.exportDocForm.printPrice),
        ORDER_ID: this.exportDocForm.ID,
      };
      this.loading3 = true;
      exportSingleDocFunc(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        this.orderPrintDialog = false;
        this.loading3 = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading3 = false;
      });
    },
    printClose () {
      this.exportDocDialog = false;
    },
    outputSupplier (row) {
      const params = {
        ORDER_ID: Number(row.ORDER_ID),
        REAL_FLAG: 1,
      };
      exportHistoryFun(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    changeStaus (tab, event) {
      sessionStorage.setItem('s_confirmOrderListActiveName', this.activeName);
    },
    exportAllOrder () {
      if (this.searchForm.DAY_INTERVAL == null || this.searchForm.DAY_INTERVAL.length == 0) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      const params = {
        START_DATE: this.searchForm.DAY_INTERVAL[0],
        END_DATE: this.searchForm.DAY_INTERVAL[1],
      };
      if (this.activeName == 'confirmList') {
        params.ORDER_STATUS = 3;
      } else {
        params.ORDER_STATUS = 4;
      }
      if (this.searchForm.TC_COMPANY) {
        params.VENDOR_ID = Number(this.searchForm.TC_COMPANY);
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.GYS_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      exportConfirmAllFun(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        this.exportTatolDialog = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>


<style scoped></style>



// WEBPACK FOOTER //
// src/components/shopOrderManage/confirmOrderList.vue